export const underAccountActionConstants = {
    FETCH_UNDER_START: 'FETCH_UNDER_START',
    FETCH_UNDER_SUCCESS: 'FETCH_UNDER_SUCCESS',
    FETCH_UNDER_ERROR: 'FETCH_UNDER_ERROR'
}